
import { Device, Vehicle } from '@clients/myTrips';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';
import { LoadState } from '@util/types';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'SetupStep3',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep3 extends Vue {
  @Prop({ required: true })
  private vehicle: Vehicle;

  @TriplogModule.Action('fetchDevice')
  private fetchDevice;

  @TriplogModule.Getter('getDevice')
  private device: Device;

  @TriplogModule.Getter('getDeviceStatus')
  private deviceStatus: LoadState;

  created() {
    if (this.vehicle && this.vehicle.deviceId) {
      this.fetchDevice({ deviceId: this.vehicle.deviceId });
    }
  }

  @Watch('vehicle')
  private vehicleUpdate() {
    if (this.vehicle && this.vehicle.deviceId) {
      this.fetchDevice({ deviceId: this.vehicle.deviceId });
    }
  }

  get publicFolder() {
    return process.env.BASE_URL;
  }

  get serialNumber() {
    if (this.device && this.device.serialNumber) {
      return this.device.serialNumber;
    }
  }

  get deviceError() {
    return (this.deviceStatus != LoadState.Success && this.deviceStatus != LoadState.Loading) ||
      (this.deviceStatus == LoadState.Success && (!this.device || !this.device.serialNumber));
  }
}
